export default defineNuxtPlugin(() => {
  if (!document.modelContext) {
    return
  }

  const nuxtApp = useNuxtApp()

  onNuxtReady(async () => {
    try {
      const { registerWebMcpTools } = await import('@layers/web/utils/webmcp-tools.ts')

      nuxtApp.runWithContext(registerWebMcpTools)
    } catch (error) {
      nuxtApp.$sentryCaptureException(error)
    }
  })
})
